"use client";
import ModalForm from "@/components/Modal/Modal";
import Image from "next/image";
import { useState } from "react";

interface HeroBlockCustomProps {
  sub_line_1: {
    title: string;
    icon: string;
  };
  sub_line_2: {
    title: string;
    icon: string;
  };
  sub_line_3: {
    title: string;
    icon: string;
  };
  color?: "violet" | "green" | "blue";
}

export default function HeroBlockCustomTabori({
  sub_line_1,
  sub_line_2,
  sub_line_3,
  color = "green",
}: HeroBlockCustomProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const backgroundColorClass =
    {
      green: "custom-gradient-green-btn",
      blue: "custom-gradient-blue-btn",
      violet: "custom-gradient-violet-btn",
    }[color] || "custom-gradient-green-btn";

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);
  return (
    <>
      <div
        data-meta="HeroBlockCustomTabori"
        className="relative container mx-auto px-4 sm:px-6 lg:px-8 mb-14"
      >
        <div className="sm:px-6 lg:mt-12 lg:px-8">
          <div className="relative">
            <div className="flex lg:hidden text-center relative  flex-col justify-end p-8 pb-16">
              <h1 className="text-3xl font-bold text-white sm:text-6xl">
                Дитячий мовний табір AP Camp
              </h1>
              <p className="mt-2 text-white">
                Мовний табір, що відкриває нові горизонти!
              </p>
              <div className="lg:hidden absolute rigth-2 bottom-11 md:bottom-8 rotate-3">
                <div className="text-sm flex gap-4 lg:text-lg backdrop-blur-sm bg-white/30 rounded-full px-1 md:px-8 md:py-1 leading-6 text-white ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                  <Image
                    src={sub_line_1.icon}
                    width={20}
                    height={20}
                     alt={""}
                  />
                  {sub_line_1.title}
                </div>
              </div>
              <div className="lg:hidden absolute bottom-4 right-2  -rotate-2">
                <div className="text-sm flex gap-4 lg:text-lg backdrop-blur-sm bg-white/30 rounded-full px-1 md:px-8 md:py-1 leading-6 text-white ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                  <Image
                    src={sub_line_2.icon}
                    width={20}
                    height={20}
                     alt={""}
                  />
                  {sub_line_2.title}
                </div>
              </div>
              <div className="lg:hidden absolute top-4 left-[30%] -rotate-2">
                <div className="text-sm flex gap-4 lg:text-lg backdrop-blur-sm bg-white/30 rounded-full px-1 md:px-8 md:py-1 leading-6 text-white ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                  <Image
                    src={sub_line_3.icon}
                    width={20}
                    height={20}
                     alt={""}
                  />
                  {sub_line_3.title}
                </div>
              </div>
            </div>
            <Image
              width={1680}
              height={700}
              src="/assets/photoHero/TaboruHero.webp"
                alt=""
              className="object-cover w-full h-full mask-second large"
            />
            <div className="hidden lg:flex absolute top-0 right-0 left-0 bottom-[15%]  flex-col justify-end p-8">
              <p className="text-3xl font-bold text-white sm:text-6xl">
                Дитячий мовний табір AP Camp
              </p>
              <p className="mt-2 text-white">
                Мовний табір, що відкриває нові горизонти!
              </p>
            </div>
            <div className="hidden lg:block absolute lg:top-[70%] xl:top-[40%] lg:right-[5%] rotate-3">
              <div className="text-sm flex gap-4 lg:text-lg backdrop-blur-sm bg-white/30 rounded-full px-1 md:px-8 md:py-1 leading-6 text-white ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                <Image
                  src={sub_line_1.icon}
                  width={20}
                  height={20}
                   alt={""}
                />
                {sub_line_1.title}
              </div>
            </div>
            <div className="hidden lg:block absolute lg:top-[20%] xl:top-[40%] left-[5%]  -rotate-2">
              <div className="text-sm flex gap-4 lg:text-lg backdrop-blur-sm bg-white/30 rounded-full px-1 md:px-8 md:py-1 leading-6 text-white ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                <Image
                  src={sub_line_2.icon}
                  width={20}
                  height={20}
                   alt={""}
                />
                {sub_line_2.title}
              </div>
            </div>
            <div className="hidden lg:block absolute bottom-[10%] left-[30%] -rotate-2">
              <div className="text-sm flex gap-4 lg:text-lg backdrop-blur-sm bg-white/30 rounded-full px-1 md:px-8 md:py-1 leading-6 text-white ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                <Image
                  src={sub_line_3.icon}
                  width={20}
                  height={20}
                   alt={""}
                />
                {sub_line_3.title}
              </div>
            </div>
            <div className=" hidden lg:block absolute top-[90%] right-0">
              <div className="flex md:gap-2 xl:gap-12 items-center">
                <p className="text-white text-xs md:text-sm xl:text-base">
                  Запишіться <br /> вже сьогодні
                </p>
                <button
                  onClick={openForm}
                  className={`uppercase ${backgroundColorClass} rounded-full px-8 py-2.5 text-center text-sm font-fixel font-bold text-white shadow-sm focus-visible:outline`}
                >
                  Забронювати
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:hidden mt-4 font-fixel py-4 text-white text-md rounded-3xl flex flex-col justify-center items-center gap-4">
          Запишіться вже сьогодні
          <button
            onClick={openForm}
            className={`${backgroundColorClass} uppercase text-white rounded-full px-8 py-2.5 text-center text-sm font-fixel font-bold focus-visible:outline`}
          >
            Забронювати
          </button>
        </div>
      </div>

      {isFormOpen && (
        <ModalForm
          closeForm={closeForm}
          btnMeta={{
            tag: "табір",
          }}
          color={color}
        />
      )}
    </>
  );
}
